import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {SubTitleMedium} from '@spaced-out/ui-design-system/lib/components/Text';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@spaced-out/ui-design-system/lib/components/Modal';
import {
  RadioGroup,
  RadioButton,
} from '@spaced-out/ui-design-system/lib/components/RadioButton';


type SetDefaultModalProps = {
  onClose: () => void;
  onConfirm: (scope: 'self' | 'everyone') => void;
};

export function SetDefaultModal({onClose, onConfirm}: SetDefaultModalProps) {
  const {t} = useLabelTranslation();
  const [scope, setScope] = React.useState<'self' | 'everyone'>('self');

  return (
    <Modal size="small" isOpen onClose={onClose} tapOutsideToClose>
      <ModalHeader onCloseButtonClick={onClose}>
        <SubTitleMedium>
          {t('Set_as_Default_Dashboard', 'Set as Default Dashboard')}
        </SubTitleMedium>
      </ModalHeader>
      <ModalBody>
        <RadioGroup
          name="home-dashboard-scope"
          value={scope}
          onChange={(val) => setScope(val as 'self' | 'everyone')}
        >
          <RadioButton value="self">
            {t(
              'Only_set_this_as_your_default_dashboard',
              'Only set this as your default dashboard',
            )}
          </RadioButton>
          <RadioButton value="everyone">
            {t(
              'Set_this_as_the_default_dashboard_for_everyone',
              'Set this as the default dashboard for everyone',
            )}
          </RadioButton>
        </RadioGroup>
      </ModalBody>
      <ModalFooter>
        <Button type="ghost" onClick={onClose}>
          {t('Cancel', 'Cancel')}
        </Button>
        <Button type="primary" onClick={() => onConfirm(scope)}>
          {t('Confirm', 'Confirm')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
